export const myCourse = {
    "no_course_yet" : "ຍັງບໍ່ທັນມີຫຼັກສູດ",
};

